import React, { useRef, useEffect } from 'react';
import useDataVersion from '../hooks/useDataVersion';

const API = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Grade Strategy Dashboard
 * Renders a self-contained HTML dashboard (with Chart.js) inside an iframe.
 * The HTML fetches its data from /api/grade-strategy/data using the parent
 * window's REACT_APP_BACKEND_URL.
 *
 * When admin publishes new rates, we reload the iframe to pick up fresh data.
 */
const GradeStrategyPage = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    window.REACT_APP_BACKEND_URL = API;
  }, []);

  useDataVersion('rates', () => {
    // Force iframe reload to refetch data
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src.split('?')[0] + '?_=' + Date.now();
    }
  }, { toastLabel: 'Grade Strategy data' });

  return (
    <div className="w-full h-full min-h-screen bg-white" data-testid="grade-strategy-page">
      <iframe
        ref={iframeRef}
        src="/grade-strategy.html"
        title="Grade Strategy Dashboard"
        className="w-full border-0"
        style={{ height: 'calc(100vh - 4rem)', minHeight: '900px' }}
      />
    </div>
  );
};

export default GradeStrategyPage;
